import { Navigate, Outlet } from "react-router-dom";

const ProtectedAdminRoute = () => {
  const data: any = localStorage.getItem("data")
    ? JSON.parse(localStorage.getItem("data") as any)
    : null;
  const roleData = data;
  return data?.token ? (
    roleData?.role?.role_code == "STATE_NODAL" ||
    roleData?.role?.role_code == "DISTRICT_NODAL" ||
    roleData?.role?.role_code == "NATIONAL_NODAL" ||
    roleData?.role?.role_code == "BOARD_NODAL" ? (
      <Outlet />
    ) : (
      <Navigate to="/" />
    )
  ) : (
    <Navigate to="/account/login" />
  );
};

export default ProtectedAdminRoute;
